<template>
  <v-container>
    <br>
    <v-row class="no-padding-row"> 
      <v-col cols="1" class="align-vertical no-padding">
        <span>Number</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Name</span>
      </v-col>

      <v-col cols="1" class="align-vertical no-padding">
        <span>Enabled</span>
      </v-col>

      <v-col cols="1" class="align-vertical no-padding">
        <span>Mirrored</span>
      </v-col>

      <v-col cols="1" class="align-vertical no-padding">
        <span>Flipped</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Main Stream Quality</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Sub Stream Quality</span>
      </v-col>

      <v-col :cols="dynamicCol" class="align-vertical no-padding">
        <span>Disable with ACC</span>
      </v-col>

      <v-col v-if="supportsAudioSettings" cols="1" class="align-vertical no-padding">
        <span>Enable Audio</span>
      </v-col>
    </v-row>
      <div v-if="cameras.length > 0">
        <CameraSettings 
          v-for="(camera, index) in cameras"
          :key="index"
          :camera="camera"
          :audio-enabled-count="camsWithAudioEnabledCount"
          :supports-audio-settings="supportsAudioSettings"
          @settingsUpdated="settingsRelay"
        />
      </div>
  </v-container>
</template>

<script>

import CameraSettings from '../components/CameraSettings.vue';

import { checkIfVersionIsAboveLimit } from '@/utils';

import { Logger } from "aws-amplify";
const logger = new Logger("Cameras");

export default {
  name: 'Cameras',
  components: {
    CameraSettings
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    firmwareVersion: {
      type: String,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      supportMap: {
        'CAMERAMATICS_D700-SD-4G': {
          from: '01.00.89',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH8-HD-4G': {
          from: '01.00.67',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH8_NT-HD-4G': {
          from: '01.01.49',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH4_NT-HD-4G': {
          from: '01.01.49',
          to: '9.99.99'
        },
        'CAMERAMATICS_JI7A-SD-4G': {
          from: '0.00.00',
          to: '9.99.99'
        }
      },
      camWithAudioEnabled: []
    }
  },
  computed: {
    cameras() {
      return this.config.device_config.video[0].camera[0].channel;
    },
    supportsAudioSettings() {
      if (!this.supportMap.hasOwnProperty(this.deviceModel)) {
        return false
      }

      return checkIfVersionIsAboveLimit(this.firmwareVersion, this.supportMap[this.deviceModel]['from'])
    },
    dynamicCol() {
      return this.supportsAudioSettings ? 1 : 2;
    },
    camsWithAudioEnabledCount() {
      const items = [...this.camWithAudioEnabled].filter(cam => JSON.parse(cam.audioCapEnabled[0]) == true)
      return items.length
    }
  },

  mounted() {
    this.camWithAudioEnabled = this.cameras.filter(cam => JSON.parse(cam.audioCapEnabled[0]) == true)
  },
  methods: {
    settingsRelay(data, map) {
      // update list of cameras as only 4 may be enabled at any time
      const pinNum = data.context.newValue
      const state = data.newValue
      const targetCamIndex = this.cameras.findIndex(cam => cam.number[0] == pinNum)
      logger.info('settings relay', data)
      if(state && data.key.includes('audioCapEnabled')) {
        this.camWithAudioEnabled.push(this.cameras[targetCamIndex])
      } else if (!state && data.key.includes('audioCapEnabled')) {
        let index = this.camWithAudioEnabled.findIndex(cam => cam.number[0] == pinNum)
        this.camWithAudioEnabled.splice(index, 1);
      }
      this.$emit('settingsUpdated', data, map);
    }
  }
}
</script>

<style lang="scss" scoped>
  .align-vertical {
    justify-content: left;
    align-items: center;
    display: flex;
  }
  .no-padding {
    padding: 0 0.25em !important;
    margin: 0 !important;
  }
</style>